import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

export default function DataIcon(props: FontAwesomeIconProps) {
    if (props.color) return <FontAwesomeIcon fixedWidth tw="mr-1" {...props} size="sm" />;
    return <FontAwesomeIcon fixedWidth tw="text-primary-500 mr-1" {...props} size="sm" />;
}
